// Constants for the community schema extension module.
// Single source of truth for all field names, metadata paths, URL prefixes,
// and link keys used across the frontend.

// Field names as stored in the record metadata object
export const COMMUNITY_EXTENSION_FIELD = "community_extension";
export const COMMUNITY_EXTENSION_SCHEMA_FIELD = "community_extension_schema";

// Dot-separated paths used in serializers and field adapters
export const COMMUNITY_EXTENSION_METADATA_PATH = "metadata.community_extension";
export const COMMUNITY_EXTENSION_SCHEMA_METADATA_PATH =
  "metadata.community_extension_schema";

// Base URL prefix for the community schema extension API (no trailing slash)
export const COMMUNITY_EXTENSION_API_PREFIX = "/api/community-schema-extension";

// Key used in the record links object for the JSON Schema extension link
export const SCHEMA_EXTENSION_LINK_KEY = "$schema-extension";
